import type { ReactNode } from 'react';

import { Box } from '@yoweb/ui/components/Box';

/**
 * TabVerticalContainer, standard spacing and alignment for the TabVertical components.
 */
const TabVerticalContainer = ({ children }: { children: ReactNode }) => (
  <Box display="grid" gap="small3" alignItems="start">
    {children}
  </Box>
);

export { TabVerticalContainer };
